import { render, staticRenderFns } from "./PresenceNgWordsAlertCount.vue?vue&type=template&id=23cf2cb4"
import script from "./PresenceNgWordsAlertCount.vue?vue&type=script&lang=js"
export * from "./PresenceNgWordsAlertCount.vue?vue&type=script&lang=js"
import style0 from "./PresenceNgWordsAlertCount.vue?vue&type=style&index=0&id=23cf2cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports